<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col mt-0">
        <h5 class="card-title">Instructor Search</h5>
      </div>
      <div class="col-auto">
        <div class="col-green">
          <i class="fas fa-search pull-left card-icon col-orange font-30"></i>

        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-auto">
        <mat-chip-listbox aria-label="Skill selection" [multiple]="false" [selectable]="true" class="chip-list">
          <mat-chip *ngFor="let chip of interestAreas" class="bg-dol-green " (click)="skillsSelected(chip)" selected>
            {{chip.interest}}
          </mat-chip>
        </mat-chip-listbox>
        <mat-chip-listbox [selectable]="true">
          <mat-chip *ngFor="let sub of subInterestAreas" class="bg-dol-green" (click)="subSkillsSelected(sub)" selected>
            {{sub}}
          </mat-chip>
        </mat-chip-listbox>
        <mat-form-field class="search-input" appearance="outline">
          <mat-label>Search</mat-label>
          <input matInput (keyup)="searchForInstructor($event)">

        </mat-form-field>
      </div>
     
    </div>
    <div class="row">
      <div class="col-md-12">
        <ul class="instructor-list">
          <li *ngFor="let instructor of instructors">
            <img class="cursor img-thumbnail" routerLink="/instructor-profile/{{instructor.userId}}"
              alt="{{instructor.firstName}} {{instructor.lastName}}" src="{{instructor.profilePicture}}" />
            <div class="info">

              <ul class="list-inline " style="padding-left: 10px;">
                <li class="list-inline-item me-2">
                  <a routerLink="/instructor-profile/{{instructor.userId}}">
                    <h2 class="title">{{instructor.firstName}} {{instructor.lastName}} </h2>
                  </a>
                </li>
                <li class="list-inline-item ms-2" *ngFor="let interest of instructor.interestAreas">{{interest}}
                </li>
              </ul>



              <p class="desc" [ngClass]="{'limitTextHeight': isReadMore}">{{instructor.bio}}

              </p>

              <a class="link-primary desc cursor" routerLink="/instructor-profile/{{instructor.userId}}">
                Read More
              </a>

              <ul class="crtls">
                <li class="webLinkArea">

                  <a href="{{instructor.webLinks[0].url}}" *ngIf="instructor.webLinks.length==1" target="_blank"><span
                      class="fa fa-globe"></span>
                    {{instructor.webLinks[0].title}}</a>
                  <select class="form-select" *ngIf="instructor.webLinks.length>1"
                    (change)="webLinkSelected($event.target.value)">
                    <option selected>View web links</option>
                    <option *ngFor="let link of instructor.webLinks" [value]="link.url">
                      {{ link.title }}
                    </option>
                  </select>

                </li>
                <li><button mat-raised-button color="primary" [routerLink]="['/book-lesson',instructor.userId]">Lesson
                    <span class="fa fa-money"></span>
                    ${{instructor.ratePerHour}}</button></li>
              </ul>
            </div>
            <div class="social">
              <ul>
                <li *ngIf="instructor.socialLinks.facebook" class="facebook" style="width:33%;"><a
                    href="{{instructor.socialLinks.facebook}}" target="_blank"><span
                      class="fab fa-facebook-f"></span></a></li>
                <li *ngIf="instructor.socialLinks.twitter" class="twitter" style="width:34%;"><a
                    href="{{instructor.socialLinks.twitter}}" target="_blank"><span class="fab fa-twitter"></span></a>
                </li>
                <li *ngIf="instructor.socialLinks.instagram" class="instagram" style="width:33%;"><a
                    href="{{instructor.socialLinks.instagram}}" target="_blank"><span
                      class="fab fa-instagram"></span></a>
                </li>
              </ul>
            </div>

          </li>
        </ul>
      </div>
    </div>

  </div>
